import React, { Component } from "react";
import { compose } from "recompose";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Typography, TableRow, TableCell, Tooltip } from "@material-ui/core";
import { green, red, orange } from "@material-ui/core/colors";
import { Check as CheckIcon, Close as CloseIcon } from "@material-ui/icons";
import MenuOptions from "./MenuOptions";

const checkedStyleYes = { padding: 0, fontSize: 28, color: green[700] };
const checkedStyleNo = { padding: 0, fontSize: 28, color: red[700] };
const checkedButton = <CheckIcon style={checkedStyleYes} />;
const unCheckedButton = <CloseIcon style={checkedStyleNo} />;
const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
});

const formatNumber = (number) =>
  formatter.format(Math.round(parseFloat(number))).replace("$", "");

const styles = (theme) => ({
  smallCell: { padding: 0 },
  smallCellBalance: {
    padding: 0,
    paddingRight: 10,
  },
  smallCellCenter: {
    padding: 0,
    textAlign: "center",
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 100,
  },
  annotation: {
    fontSize: "13px",
    color: "#333",
    fontWeight: "normal",
    cursor: "pointer",
  },
});

class PlayerRow extends Component {
  shouldComponentUpdate(nextProps) {
    return (
      Boolean(nextProps.anchorEl) !== Boolean(this.props.anchorEl) ||
      this.props.player.IdPlayer !== nextProps.player.IdPlayer ||
      Boolean(nextProps.showPassword) !== Boolean(this.props.showPassword)
    );
  }
  render() {
    const {
      player,
      i,
      anchorEl,
      classes,
      menuClick,
      handleMenuClick,
      handleMenuClose,
      createPlayerPriv,
      showPassword,
      onPasswordClick,
    } = this.props;
    const currentBalance = Math.round(parseFloat(player.CurrentBalance));
    const separatedLastWager = player.LastWager.split(" ");
    let enabledColor = orange[700];
    let enabledText = "";
    if (player.Enabled && !player.OnlineAccess) {
      enabledColor = orange[700];
      enabledText = "Phone Only";
    } else if (!player.Enabled && player.OnlineAccess) {
      enabledColor = orange[700];
      enabledText = "Web Only";
    }
    if (player.Enabled && player.OnlineAccess) {
      enabledColor = green[700];
      enabledText = "YES";
    } else if (!player.Enabled && !player.OnlineAccess) {
      enabledColor = red[700];
      enabledText = "NO";
    }
    return (
      <TableRow
        key={`player-row-management-${player.IdPlayer}`}
        style={{ backgroundColor: i % 2 ? "#fff" : "#eee" }}
      >
        <TableCell className={classes.smallCell}>
          <strong>
            <player>
              <a
                className="plrlnk"
                href={`PlayerDetails.aspx?Account=${player.Player}`}
              >
                {player.Player}
              </a>
            </player>
          </strong>{" "}
          <br />
          <Tooltip
            title={showPassword ? "Password" : "Name"}
            placement={"bottom"}
          >
            <Typography
              className={classes.annotation}
              onClick={() => onPasswordClick()}
            >
              {showPassword ? player.Password : player.Name}
            </Typography>
          </Tooltip>
        </TableCell>
        <TableCell className={classes.smallCell}>
          <Typography style={{ color: enabledColor }}>{enabledText}</Typography>
        </TableCell>
        <TableCell className={classes.smallCell}>
          {formatNumber(player.MaxWager)}
        </TableCell>
        <TableCell className={classes.smallCell}>
          {formatNumber(player.MinWager)}
        </TableCell>
        <TableCell className={classes.smallCell}>
          {formatNumber(player.CreditLimit)}
        </TableCell>
        <TableCell className={classes.smallCellCenter}>
          {player.EnableSports ? checkedButton : unCheckedButton}
        </TableCell>
        <TableCell className={classes.smallCellCenter}>
          {player.EnableCasino ? checkedButton : unCheckedButton}
        </TableCell>
        <TableCell className={classes.smallCellCenter}>
          {player.EnableHorses ? checkedButton : unCheckedButton}
        </TableCell>
        <TableCell
          className={classes.smallCellBalance}
          style={{ color: currentBalance < 0 ? red[700] : "#000" }}
        >
          {formatNumber(currentBalance)}
        </TableCell>
        <TableCell className={classes.smallCellCenter}>
          {separatedLastWager[0]} <br />
          {separatedLastWager[1]}
        </TableCell>
        <TableCell className={classes.smallCell} style={{ padding: 0 }}>
          <MenuOptions
            {...{
              anchorEl,
              player,
              menuClick,
              handleMenuClick,
              handleMenuClose,
              createPlayerPriv,
            }}
          />
        </TableCell>
      </TableRow>
    );
  }
}

PlayerRow.propTypes = {
  i: PropTypes.number.isRequired,
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  player: PropTypes.object.isRequired,
  anchorEl: PropTypes.object.isRequired,
  menuClick: PropTypes.func.isRequired,
  handleMenuClick: PropTypes.func.isRequired,
  handleMenuClose: PropTypes.func.isRequired,
  createPlayerPriv: PropTypes.bool.isRequired,
  showPassword: PropTypes.bool.isRequired,
  onPasswordClick: PropTypes.func.isRequired,
};

export default compose(
  withStyles(styles, {
    name: "PlayerRow",
    withTheme: true,
  })
)(PlayerRow);
